import React, { Component } from 'react';

import './style.sass';
import CommonTitle from '../../../common-components/common-title';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonUsualText from '../../../common-components/common-usual-text';

class Process extends Component {
    render() {
        return (
            <div className="gapresource-process">
                <div className="gapresource-process__inner">
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                    >
                        <div className="gapresource-process__wrapper">
                            <CommonTitle className="gapresource-process__title">
                                Процесс
                            </CommonTitle>

                            <div className="gapresource-process__container">
                                <CommonUsualText className="gapresource-process__text">
                                    Для работы над сайтом компании ГАП «Ресурс» в агентстве создали
                                    команду, которой руководил менеджер проекта. Он следил за
                                    этапами работы, соблюдением сроков, ресурсами, документацией и
                                    был на связи с заказчиком. <br /> <br />
                                    Работа над проектом строится из нескольких этапов и начинается с
                                    формирования четкого техзадания, от которого зависит восприятие
                                    будущего сайта, его функциональность и сроки выполнения работы.
                                </CommonUsualText>
                                <img
                                    className="gapresource-process__img"
                                    src="/images/pic/gapresource/gapresurs 1.jpg"
                                    alt="pill"
                                    loading="lazy"
                                />
                            </div>
                            <div className="gapresource-process__container">
                                <img
                                    className="gapresource-process__img"
                                    src="/images/pic/gapresource/gapresurs 2.jpg"
                                    alt="pill"
                                    loading="lazy"
                                />
                                <CommonUsualText className="gapresource-process__text">
                                    Далее наша команда разработала прототип нового сайта и
                                    предложила две креативные концепции на выбор. После доработки и
                                    согласования финального варианта разработали UI-кит сайта для
                                    всех устройств. <br /> <br />
                                    Проект реализовали на платформе Битрикс с помощью Kubernetes.
                                    Для разработки сайта выбрали эту систему как основу. С помощью
                                    React полностью отрисовали и сверстали сайт, разработали шаблоны
                                    страниц и блоков. Особое внимание уделили отображению картинок
                                    для десктопа и адаптива.
                                </CommonUsualText>
                            </div>
                            <div className="gapresource-process__container">
                                <CommonUsualText className="gapresource-process__text">
                                    Новая структура сайта адаптирована для функциональной нагрузки с
                                    учетом большого количества медиафайлов. Навигация удобная и
                                    интуитивно-понятная. В дизайне главной страницы клиент хотел
                                    отразить глобальность, инновационность и технологичность
                                    компании ГАП «Ресурс».
                                </CommonUsualText>
                                <img
                                    className="gapresource-process__img"
                                    src="/images/pic/gapresource/gapresurs 3.jpg"
                                    alt="pill"
                                    loading="lazy"
                                />
                            </div>
                        </div>
                    </ScrollAnimation>
                </div>
            </div>
        );
    }
}

export default Process;
